export const SPORTS_GET_REQUEST = "@sports.get.request";
export const SPORTS_GET_SUCCESS = "@sports.get.success";
export const SPORTS_GET_FAIL = "@sports.get.failure";
